// The inbound voicemail player (moved out of pages/Tasks.tsx on 2026-10-24 so the Missed calls page plays a voicemail the
// same way). GET /api/inbound/voicemails/:id/audio; a failed load shows the server's reason instead of a silent 0:00.
import { useState } from 'preact/hooks';
import { errorMessage } from '../api';
import { Spinner } from '../components/ui-extra';
import { voicemailAudioProblem } from './audio';
import { endpoints } from './endpoints';

/** The recording player. A failed load shows the server's reason instead of a silent 0:00 player. */
export function VoicemailAudio(props: { id: number }) {
  const url = endpoints.voicemailAudioUrl(props.id);
  const [attempt, setAttempt] = useState(0);
  const [problem, setProblem] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);
  const onError = async () => {
    if (checking) return;
    setChecking(true);
    try {
      const res = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (res.ok) {
        try { await res.body?.cancel(); } catch { /* nothing to stop */ }
        setProblem(voicemailAudioProblem({ status: res.status }));
      } else {
        setProblem(voicemailAudioProblem({ status: res.status, body: await res.text() }));
      }
    } catch (e) {
      setProblem(voicemailAudioProblem({ status: null, networkError: errorMessage(e) }));
    } finally {
      setChecking(false);
    }
  };
  return (
    <div style="margin-top:6px">
      {problem ? null : (
        <audio key={attempt} controls preload="none" src={url} style="max-width:100%;height:32px" onError={() => void onError()} />
      )}
      {checking ? <span class="muted" style="font-size:13px"><Spinner /> Checking the recording…</span> : null}
      {problem ? (
        <div class="row" style="gap:8px;flex-wrap:wrap" role="alert">
          <span class="vd-bad" style="font-size:13px">{problem}</span>
          <button class="btn btn-sm" onClick={() => { setProblem(null); setAttempt((n) => n + 1); }}>Try again</button>
        </div>
      ) : null}
    </div>
  );
}
